import React from "react";
import { STATUS_TONE, fmtMetric } from "./format";

// One KPI card: Target / Actual / Expected by now / Variance / Status (spec §5).
export default function KpiCard({ kpi }) {
  const tone = STATUS_TONE[kpi.status] || "muted";
  const varPositive = kpi.variance != null && kpi.variance >= 0;

  return (
    <div className={`kpi-card tone-${tone}`}>
      <div className="kpi-card-head">
        <span className="kpi-metric">{kpi.metric}</span>
        <span className={`status-chip tone-${tone}`}>{kpi.status}</span>
      </div>

      <div className="kpi-actual">{fmtMetric(kpi.actual, kpi.unit)}</div>

      <div className="kpi-grid">
        <div>
          <span className="kpi-k">Target</span>
          <span className="kpi-v">{fmtMetric(kpi.target, kpi.unit)}</span>
        </div>
        <div>
          <span className="kpi-k">Expected by now</span>
          <span className="kpi-v">{kpi.expected == null ? "—" : fmtMetric(kpi.expected, kpi.unit)}</span>
        </div>
        <div>
          <span className="kpi-k">Variance</span>
          <span className={`kpi-v ${kpi.variance == null ? "" : varPositive === !(/lower/.test(kpi.direction)) ? "up" : "down"}`}>
            {kpi.variance == null ? "—" : `${varPositive ? "+" : ""}${fmtMetric(kpi.variance, kpi.unit)}`}
          </span>
        </div>
      </div>

      {kpi.explanation && <p className="kpi-note">{kpi.explanation}</p>}
    </div>
  );
}
